export default __webpack_public_path__ + "static/media/ls.67911125.jpg";